import { css } from "styled-components";

export const searchFormFieldStyle = css`
    &.aevi-search-form-field-container {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        gap: 15px;

        & > div {
            width: 25%;
        }

        & .aevi-form-field-vertical {
            div {
                gap: 0;
            }
        }
    }
`;
